import { LiquidationAgreement } from 'features/SubmitProjectProposal/pages';

import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';
import { Can } from 'components/Can';

function LiquidationAgreementPage() {
  return (
    <LayoutProvider>
      <Layout>
        <Can do="create" on="liquidation">
          <LiquidationAgreement />
        </Can>
      </Layout>
    </LayoutProvider>
  );
}

export default LiquidationAgreementPage;
